import { TableHeader } from "@/models/TableHeader";

export const categoriesHeader: TableHeader[] = [
  {
    text: "Name",
    value: "name",
    width: "15rem"
  },
  {
    text: "URL",
    value: "slug",
    width: "15rem"
  },
  {
    text: "Last Update",
    value: "updated_at",
    width: "8rem"
  },
  {
    text: "Description",
    value: "description",
    width: "48rem"
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];

export const entriesHeader: TableHeader[] = [
  {
    text: "Category Name",
    value: `category.title`,
    width: "15rem"
  },
  {
    text: "Title",
    value: "title",
    width: "20rem"
  },
  {
    text: "Content",
    value: "content",
    width: "45rem"
  },
  {
    text: "Last Update",
    value: "updated_at",
    width: "8rem"
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
